import apiService from './api-service'

const tasksService = {}

/**
 * Create a task.
 * @param  {string} creatorType
 * @param  {object} body
 * @return {Promise}
 */
tasksService.post = function (creatorType, body) {
  switch (creatorType) {
    case 'prospect':
      return apiService.post(`/prospects/task`, body).then(res => res.data)
    default:
      throw Error('Invalid creator type for task.')
  }
}

/**
 * Retrieve a task by it's id
 * @param  int id
 * @param  array params (optional)
 * @return task
 */
tasksService.getById = function (id) {
  return apiService.get(`/task/${id}`, { id }).then(res => res.data).catch(error => error)
}

/**
 * Update a tasks by it's id
 * @param  int id
 * @param  array params (optional)
 * @return tasks
 */
tasksService.updateById = function (id, body) {
  body['_method'] = 'PUT'
  return apiService.put(`/task/${id}`, body).then(res => res.data)
}

export default tasksService



// WEBPACK FOOTER //
// ./src/services/tasks.js